import { render, staticRenderFns } from "./TotalsContainerComponent.vue?vue&type=template&id=35f4f68b&scoped=true&lang=pug"
import script from "./TotalsContainerComponent.vue?vue&type=script&lang=ts"
export * from "./TotalsContainerComponent.vue?vue&type=script&lang=ts"
import style0 from "./TotalsContainerComponent.vue?vue&type=style&index=0&id=35f4f68b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f4f68b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f4f68b')) {
      api.createRecord('35f4f68b', component.options)
    } else {
      api.reload('35f4f68b', component.options)
    }
    module.hot.accept("./TotalsContainerComponent.vue?vue&type=template&id=35f4f68b&scoped=true&lang=pug", function () {
      api.rerender('35f4f68b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Totals/TotalsContainerComponent.vue"
export default component.exports